import { Profile } from "../../models";

export interface ProfileListResult {
  profiles: Profile[];
  profileCount: number;
}
